import { useTranslation } from "react-i18next";
import {
  Dialog as ShadcnDialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Button } from "../ui";

export type DialogProps = {
  title: string;
  description?: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  width?: string;
  maxWidth?: string;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onSubmit?: () => void;
  trigger?: React.ReactNode;
  externalTrigger?: boolean;
  defaultActions?: boolean;
};

export function Dialog({
  trigger = undefined,
  externalTrigger = false,
  defaultActions = false,
  actions,
  title,
  description,
  children,
  maxWidth = "100%",
  width = "450px",
  className = "",
  open,
  onOpenChange = () => {},
  onSubmit = () => {},
}: DialogProps) {
  return (
    <ShadcnDialog open={open} onOpenChange={onOpenChange}>
      {!externalTrigger && (
        <DialogTrigger className={className} asChild>
          {trigger}
        </DialogTrigger>
      )}

      <DialogContent
        className={`text-left`}
        style={{
          width: width,
          maxWidth: maxWidth,
          maxHeight: "90vh",
          overflowY: "scroll",
        }}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        <DialogFooter>
          {actions ? (
            actions
          ) : defaultActions ? (
            <DialogActions
              onSubmit={onSubmit}
              onCancel={() => onOpenChange(false)}
            />
          ) : null}
        </DialogFooter>
      </DialogContent>
    </ShadcnDialog>
  );
}

export function DialogActions({
  onSubmit,
  onCancel,
}: {
  onSubmit: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full justify-end space-x-2">
      <Button variant="ghost" onClick={() => onCancel()}>
        {t("common.cancel")}
      </Button>
      <Button variant="default" onClick={onSubmit}>
        {t("common.confirm")}
      </Button>
    </div>
  );
}
